// Mode Démo / Sandbox du CRM
// Permet de basculer entre données réelles (is_demo = false) et données de test (is_demo = true)
// Le mode est persisté dans localStorage et notifié globalement.

import { useSyncExternalStore } from 'react';

const STORAGE_KEY = 'crm-demo-mode';

let _demoMode: boolean = (() => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
})();

const listeners = new Set<() => void>();

export function getDemoMode(): boolean {
  return _demoMode;
}

export function setDemoMode(on: boolean) {
  if (_demoMode === on) return;
  _demoMode = on;
  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
    // Notifie le store CRM pour recharger les données
    const reload = (window as any).__crmReloadOnDemoChange;
    if (typeof reload === 'function') reload();
  }
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useDemoMode(): [boolean, (on: boolean) => void] {
  const value = useSyncExternalStore(subscribe, getDemoMode, getDemoMode);
  return [value, setDemoMode];
}

// Helpers utilisés par le store pour filtrer/injecter le flag is_demo
export function demoFilterValue(): boolean {
  return _demoMode;
}

export function withDemoFlag<T extends Record<string, any>>(row: T): T & { is_demo: boolean } {
  return { ...row, is_demo: _demoMode };
}

export function withDemoFlagArray<T extends Record<string, any>>(rows: T[]): (T & { is_demo: boolean })[] {
  return rows.map((r) => ({ ...r, is_demo: _demoMode }));
}
